import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9 16v1h1v-1H9zm7-13.523C16 1.665 15.369 1 14.597 1H4.403C3.631 1 3 1.665 3 2.477v15.046C3 18.335 3.631 19 4.403 19h10.194c.772 0 1.403-.665 1.403-1.477V2.477zM15 15v2.523c0 .258-.184.477-.403.477H4.403C4.184 18 4 17.781 4 17.523V15h11zm0-1H4V4h11v10zm0-11.523V3H4v-.523C4 2.219 4.184 2 4.403 2h10.194c.219 0 .403.219.403.477z',
  ],
  height: 20,
  width: 20,
});
